import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { useIdentity } from '@whizz/react-identity';
import { ProductFruits, isProductFruitsReady, useProductFruitsApi } from 'react-product-fruits';
import { PRODUCT_FRUITS_TOURS } from '../../util/vars';
import { useCleverIntegration } from '../../hooks/useCleverIntegration';

const Nudges = () => {

  const { me } = useIdentity();
  const [ isClever ] = useCleverIntegration();
  const { locale } = useI18n();
  const workspaceCode = process.env.REACT_APP_PRODUCT_FRUITS_TOKEN;

  if (!me || !workspaceCode) {
    return null;
  }

  const userInfo = {
    username: me?.id.toString(),
    props: {
      locale: locale?.id ?? 'en-gb',
      isMis: String(isClever),
    },
  };

  useProductFruitsApi((api) => {
    if (isProductFruitsReady()) {
      api.tours.listen('tour-skipped', (tourId: number) => {
        api.tours.tryStartTour(PRODUCT_FRUITS_TOURS.lifeRing);
      });
    }
  }, [ isProductFruitsReady ]);

  return (
    <ProductFruits workspaceCode={workspaceCode} language={locale?.language ?? 'en'} user={userInfo} />
  );
};

Nudges.defaultName = 'Nudges';

export default Nudges;
